angular.module('leanlaw').controller('ClientViewCtrl', ['$scope', 'alerts', function ($scope) {
  const tabs = [{
    label: 'Info',
    route: `${$scope.module.root}.client.view.info`
  }, {
    label: 'Overview',
    route: `${$scope.module.root}.client.view.overview`,
    show: ({
      me
    }) => me && me.permissions.matters.overview
  }, {
    label: 'Billing Activity',
    route: `${$scope.module.root}.client.view.billingActivity`,
    show: ({
      me
    }) => me && me.permissions.billing.view && me.permissions.matters.overview
  }, {
    label: 'Lean Align Settings',
    route: `${$scope.module.root}.client.view.leanAlign`,
    show: ({
      me
    }) => me && me.features.expenseAttachments && me.access.setup
  }, {
    label: 'LEDES',
    route: `${$scope.module.root}.client.view.ledes`,
    show: ({
      me
    }) => me && me.features.ledesXml2
  }];
  $scope.vm = {
    tabs
  };
}]);